import React from 'react';
import { State } from 'src/redux/reducer';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import cn from 'classnames/bind';
import styles from './styles.styl';

import { IconCheck } from '@consta/uikit/IconCheck';
import { putTakingSurveySelector } from 'src/redux/features/surveys/putTakingSurvey/selectors';
import { connect } from 'react-redux';
import { IScore } from 'src/redux/features/surveys/putTakingSurvey/types';
import { SurveyStatusEnum, SurveyTypeEnum } from 'src/utils/enum';
import parse from 'html-react-parser';

const cx = cn.bind(styles);

export interface TakingSurveyFinalProps {
  title: string;
  description: string;
  score: IScore;
  maxScore: number;
  status: number;
}

const TakingSurveyFinal: React.FC<TakingSurveyFinalProps> = ({
  title,
  description,
  score,
  maxScore,
  status,
}) => {
  const { survey_type, points, passing_score } = score;

  const testSuccessfully: boolean = points >= passing_score;
  const isTest: boolean = survey_type === SurveyTypeEnum.TEST;

  const changeDescriptionLinks = (description: string) => {
    // const newDescription = description.split(" ", n);
    const newDescription = description.replace(
      /((http|https|ftp):\/\/[\w?=&./-;#~%-]+(?![\w\s?&./;#~%"=-]*>))/g,
      `<a href='$1' target='_blank' rel="noopener">$1</a>`,
    );
    return newDescription;
  };

  const changedDescription = changeDescriptionLinks(description);
  const changedTitle = changeDescriptionLinks(title);

  const scoreContent =
    !isTest || status === SurveyStatusEnum.DRAFT ? null : (
      <div className={cx('TakingSurveyFinal__score')}>
        <Text
          size="xl"
          view={testSuccessfully ? 'success' : 'alert'}
          weight="bold"
        >{`${points} баллов`}</Text>
        <Text
          className={cx('TakingSurveyFinal__conclusion')}
          size="m"
          weight="bold"
        >
          {testSuccessfully ? 'Это успех!' : 'Вы способны на большее!'}
        </Text>
        <Text size="m">{`Вы набрали ${points} из ${maxScore}`}</Text>
        {!testSuccessfully && (
          <Button
            className={cx('TakingSurveyFinal__button')}
            view="ghost"
            size="l"
            label="Пройти тест еще раз"
            onClick={() => window.location.reload()}
          />
        )}
      </div>
    );

  return (
    <div className={cx('TakingSurveyFinal')}>
      <div className={cx('TakingSurveyFinal__iconContainer')}>
        <IconCheck className={cx('TakingSurveyFinal__icon')} />
      </div>
      <Text className={cx('TakingSurveyFinal__title')} size="2xl">
        {parse(changedTitle)}
      </Text>
      <Text className={cx('TakingSurveyFinal__description')} size="m">
        {parse(changedDescription)}
      </Text>
      {scoreContent}
    </div>
  );
};
const mapStateToProps = (state: State) => ({
  score: putTakingSurveySelector(state),
});

export default connect(mapStateToProps, null)(TakingSurveyFinal);
